// extracted by mini-css-extract-plugin
module.exports = {"form":"FormRent_form__1RI3v","captain":"FormRent_captain__EoSEa","linkUserAgreement":"FormRent_linkUserAgreement__1hRTb"};